import { doc, updateDoc, getDoc } from "firebase/firestore";
import { db } from "config/firebase";
import { storage } from "config/firebase";
import { ref, deleteObject } from "@firebase/storage";
import { Attachment } from "@freetech/models";

/**
 * Removes an attachment from a bug report and deletes it from storage
 * @param bugReportId The ID of the bug report
 * @param attachmentId The ID of the attachment to remove
 */
export const removeBugReportAttachment = async (
  bugReportId: string,
  attachmentId: string
): Promise<void> => {
  try {
    const bugReportRef = doc(db, "bugReports", bugReportId);


    const bugReportDoc = await getDoc(bugReportRef);
    if (!bugReportDoc.exists()) {
      throw new Error("Bug report not found");
    }

    const currentAttachments = bugReportDoc.data()?.attachments || [];


    const attachmentToRemove = currentAttachments.find(
      (attachment: Attachment) => attachment.id === attachmentId
    );

    if (!attachmentToRemove) {
      throw new Error("Attachment not found");
    }


    try {

      const fileName = attachmentToRemove.name;
      const storageRef = ref(storage, `bugReports/${bugReportId}/${fileName}`);
      await deleteObject(storageRef);
    } catch (error) {
      console.error("Error deleting file from storage:", error);

    }


    const updatedAttachments = currentAttachments.filter(
      (attachment: Attachment) => attachment.id !== attachmentId
    );


    await updateDoc(bugReportRef, {
      attachments: updatedAttachments,
      updatedAt: new Date().toISOString(),
    });
  } catch (error) {
    console.error("Error removing attachment:", error);
    throw error;
  }
};
